// Per-status palette + ERP enum → design key mapping. Single source of truth
// shared between Services and Employee Schedule filter chips.
import * as statuses from "./status.constants";

export const STATUS_THEME = {
  in_progress: {
    label: "In progress",
    bg: "#EAF7EE",
    fg: "#3B8C35",
    chip: "#4BB543"
  },
  paused: {
    label: "Paused",
    bg: "#FFF4E0",
    fg: "#B7791F",
    chip: "#E8A93A"
  },
  pending: {
    label: "Pending",
    bg: "#EEEDF4",
    fg: "#1E1A45",
    chip: "#292359"
  },
  requested: {
    label: "Requested",
    bg: "#EEEDF4",
    fg: "#1E1A45",
    chip: "#292359"
  },
  completed: {
    label: "Completed",
    bg: "#EEEEEE",
    fg: "#555555",
    chip: "#8E8E8E"
  },
  cancelled: {
    label: "Cancelled",
    bg: "#F8E8E8",
    fg: "#BA1A1A",
    chip: "#BA1A1A"
  }
};

export const ERP_TO_DESIGN_KEY = {
  [statuses.IN_PROGRESS]: "in_progress",
  [statuses.PAUSED]: "paused",
  [statuses.ACCEPTED]: "pending",
  [statuses.PENDING]: "requested",
  [statuses.FINISHED]: "completed",
  [statuses.CANCELED]: "cancelled"
};
